import React from 'react';
import { Hero } from '../components/Hero';
import { SectionDirectory } from '../components/SectionDirectory';
import { SectionNav } from '../components/SectionNav';
export function Home() {
  return <>
      <Hero data-id="element-382" data-mp="2s6czr02sd9ap" />
      <SectionDirectory data-id="element-383" data-mp="2s7xryj1mog5e" />
      <SectionNav currentIndex="04" data-id="element-384" data-mp="2s8pobw31uhwq" />
    </>;
}